import { useSelector } from "react-redux";
import {
  canManageContent,
  canAddCourse,
  canAddPolicy,
  canManageInstructors,
  hasPolicyPartnerAdminAccess,
  hasPolicyPartnerLearnerAccess,
  canViewEmployeeAssignments,
  canEditEmployeeAssignments,
  notSaveEmployeeAssignments,
  showFeatureSettings
} from "../../utils/permission_authorization";

const usePermissions = () => {
  const permissions = useSelector(state => state.userState.user.permissions);
  const {
    allowValidate,
    allowValidateRole,
    hasValidateEnableMysteryShopReview,
    isAdmin,
    isInstructor
  } = permissions;
  return {
    ...permissions,
    canManageContent: canManageContent(permissions),
    canAddCourse: canAddCourse(permissions),
    canAddPolicy: canAddPolicy(permissions),
    canManageInstructors: canManageInstructors(permissions),
    hasPolicyPartnerAdminAccess: hasPolicyPartnerAdminAccess(permissions),
    hasPolicyPartnerLearnerAccess: hasPolicyPartnerLearnerAccess(permissions),
    canEditEmployeeAssignments: canEditEmployeeAssignments(permissions),
    canViewEmployeeAssignments: canViewEmployeeAssignments(permissions),
    notSaveEmployeeAssignments: notSaveEmployeeAssignments(permissions),
    showFeatureSettings: showFeatureSettings(permissions),
    isAdminOrInstructor: isInstructor || isAdmin,
    isValidateOnly:
      allowValidate &&
      (allowValidateRole || hasValidateEnableMysteryShopReview) &&
      !isAdmin
  };
};

export default usePermissions;
